import { ref } from 'vue';

import { getMenuCategory, getMenuCategories, storeMenuCategory, deleteMenuCategory } from '@/api/menu_categories';

export default function useMenuCategories(menuId = null) {
  const articles = ref([]);
  const category = ref({});
  const categories = ref([]);
  const categoryMeta = ref([]);

  const fetchMenuCategory = async (id, menuId) => {
    const fetchedCategory = await getMenuCategory(id, menuId);
    category.value = fetchedCategory.data;
  };

  const fetchMenuCategories = async () => {
    const fetchedCategories = await getMenuCategories(menuId);
    categories.value = fetchedCategories.data;
    categoryMeta.value = fetchedCategories.meta;
    if (fetchedCategories.included) {
      articles.value = fetchedCategories.included.filter((item) => {
        return item.type == 'menu-items';
      });
    } else {
      articles.value = [];
    }
  };

  const saveMenuCategory = async (category) => {
    const updatedCategory = await storeMenuCategory(category);
    return updatedCategory;
  };

  const removeMenuCategory = async (category, moreIds) => {
    const categoryDeleted = await deleteMenuCategory(category, moreIds);
    return categoryDeleted;
  };

  return {
    articles,
    category,
    categories,
    categoryMeta,
    fetchMenuCategory,
    fetchMenuCategories,
    saveMenuCategory,
    removeMenuCategory,
  };
}
